import React from 'react'
import './style.css'

import defaultEmptyIconSrc from './defaultEmpty.svg'
import emptyIconSrc from './empty.svg'

export const ResultType = {
  DEFAULT_EMPTY: 'defaultEmpty',
  EMPTY: 'empty'
}

const RESULT_TYPES = {
  [ResultType.DEFAULT_EMPTY]: {
    title: 'Nothing to See Here!',
    description: 'Looks like nothing’s happened yet. We’ll fill this area with app information, warnings and errors when something comes up.',
    iconSrc: defaultEmptyIconSrc
  },
  [ResultType.EMPTY]: {
    title: 'No Results',
    description: 'Sorry, we couldn’t find any errors that matched. Try another search!',
    iconSrc: emptyIconSrc
  }
}

const EmptyMonitorResults = ({ resultType }) => (
  <div className="empty-monitor-results">
    <img
      className="empty-monitor-results"
      src={RESULT_TYPES[resultType].iconSrc}
      alt="no results"
    />
    <span className="empty-monitor-results-title">
      {RESULT_TYPES[resultType].title}
    </span>
    <p className="empty-monitor-results-description">
      {RESULT_TYPES[resultType].description}
    </p>
  </div>
)

export default EmptyMonitorResults
